import Order from './Order'

export default class SheinOrder extends Order {
  static fields () {
    return {
      platform: this.string('Shein'),
      isPrime: this.boolean(false)
    }
  }

  static getSheetName () {
    return 'Upload waybill templates'
  }

  static fileType = 'xlsx';

  static getFileHeader () {
    return [
      'Order Number',
      'Item ID',
      'Waybill number',
      'Logistician',
      'Delete'
    ]
  }

  getFileRows () {
    return this.shipments.map(shipment => [
      this.orderId,
      shipment.orderItemId,
      shipment.trackingNumber,
      SheinOrder.carrierMap[shipment.carrierName],
      ''
    ])
  }

  static carrierMap = {
    FEDEX: 'FedEx',
    UPS: 'UPS',
    USPS: 'USPS'
  }
}



// WEBPACK FOOTER //
// ./src/orm/models/Order/SheinOrder.js